import { match } from 'ts-pattern';

import { BRANDS } from '~/domains/auth/consts';

type TitleConfig = {
  headerTitle: string;
  showSubtitle: boolean;
  reviewTitle: string;
};

type GetTitleConfigParams = {
  operation: 'create' | 'edit' | 'restart' | 'init';
  brand?: string;
};

export function getTitleConfig({ operation, brand }: GetTitleConfigParams): TitleConfig {
  return match(operation)
    .with('create', () => ({
      headerTitle: 'Create contest',
      showSubtitle: false,
      reviewTitle: 'Contest setup',
    }))
    .with('init', () => ({
      headerTitle: 'Create contest',
      showSubtitle: false,
      reviewTitle: 'Contest setup',
    }))
    .with('edit', () => ({
      headerTitle: 'Edit contest',
      showSubtitle: false,
      reviewTitle: '',
    }))
    .with('restart', () => ({
      headerTitle: 'Restart your contest',
      showSubtitle: brand !== BRANDS.SPLASH,
      reviewTitle: 'Review contest settings',
    }))
    .exhaustive();
}
